module.exports = __webpack_public_path__ + "static/media/video-pleasant-es.ad382d98.vtt";